// Bloque 12 — Normalización de roles (frontend).
// Espejo del backend `role_utils.py`. Mismo mapa de alias, ADITIVO únicamente
// (une variantes del mismo rol real, nunca amplía a roles distintos).

export const ROLE_ALIASES = {
  "Gerente Tecnico": "Gerencia Técnica",
  "Compras": "Jefe de Compras",
  "Ingeniero Residente": "Residente de Obra",
  "RRHH": "Jefe de RRHH",
};

export function normalizeRole(role) {
  if (!role) return role;
  return ROLE_ALIASES[role] || role;
}

// Reemplaza los `allowedRoles.includes(userRole)` directos: normaliza ambos
// lados antes de comparar para que el rol real equivalente quede reconocido
// aunque la lista todavía contenga la variante legacy.
export function roleAllowed(userRole, allowedRoles) {
  if (!allowedRoles) return true;
  if (allowedRoles === "*") return true;
  const normalizedUser = normalizeRole(userRole);
  return allowedRoles.some((r) => normalizeRole(r) === normalizedUser);
}
